import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { currentUser, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      alert('Logged out successfully');
      navigate('/'); 
    } catch (error) {
      console.error('Logout error:', error);
      alert('Error during logout');
    }
  };

  const getUserInitial = () => {
    if (currentUser?.displayName) {
      return currentUser.displayName[0].toUpperCase();
    } else if (currentUser?.email) {
      return currentUser.email[0].toUpperCase();
    }
    return 'U';
  };

  return (
    <header className="nav-header">
      <nav className="nav-content">
        <div className="nav-left">
          <button className="back-btn" onClick={() => navigate(-1)}>← Back</button>
          <div className="nav-brand">
            <Link to="/">MV Profile</Link>
          </div>
        </div>

        <ul className="nav-list">
          <li><Link to="/MHMV-profile/job-search">Find Jobs</Link></li>
          <li><Link to="/MHMV-profile/job-posting">Post a Free Job</Link></li>

          <li className="dropdown">
            <Link to="#" className="dropbtn">Courses</Link>
            <div className="dropdown-content">
              <Link to="/MHMV-profile/audio-courses/admin">Audio Courses</Link>
              <Link to="/MHMV-profile/video-course-home">Video Courses</Link>
            </div>
          </li>

          <li className="dropdown">
            <Link to="#" className="dropbtn">Services</Link>
            <div className="dropdown-content">
              <Link to="/android-dev">Android Development</Link>
              <Link to="/custom-software">Custom Software Development</Link>
              <Link to="/it-consulting">IT Consulting</Link>
              <Link to="/web-dev">Web Development</Link>
              <Link to="/mobile-app">Mobile App Development</Link>
              <Link to="/training">Training</Link>
              <Link to="/career-dev">Career Development Coaching</Link>
              <Link to="/corporate-training">Corporate Training</Link>
              <Link to="/cloud-app">Cloud Application Development</Link>
            </div>
          </li>

          
          {!currentUser ? (
            <>
              <li><Link to="/MHMV-profile/jobseeker-login">Job Seeker Login</Link></li>
              <li><Link to="/MHMV-profile/employee-login">Employee Login</Link></li>
            </>
          ) : (
            <li className="dropdown">
              <Link to="#" className="dropbtn user-dropdown">
                <div className="user-avatar-small">{getUserInitial()}</div>
              </Link>
              <div className="dropdown-content user-dropdown-content">
                <Link to="/MHMV-profile/profile">View Profile</Link>
                <Link to="/settings">Settings</Link>
                <button onClick={handleLogout} className="logout-btn">Logout</button>
              </div>
            </li>
          )}
        </ul>

        <button
          className="menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          ☰
        </button>
      </nav>
    </header>
  );
};

export default Navbar;
